import Provider from './provider.component';

export default Provider;
